var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRaisedHands = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#0EB0B0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.216.003a.95.95 0 0 0-.553.126.95.95 0 0 1 .477.825V5.52a.477.477 0 1 0 .953 0V.98c0-.502-.377-.937-.877-.977"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.186 5.5h.002V.954a.954.954 0 0 1 1.907 0v.972A.954.954 0 0 1 20 1.973l.046 6.03a.188.188 0 0 0 .316.135l1.226-1.164a.871.871 0 0 1 1.268 1.192l-3.746 4.465c-.362.431-.896.68-1.458.68h-3.378a1.903 1.903 0 0 1-1.903-1.903V3.875a.954.954 0 0 1 1.907-.016V1.973a.954.954 0 0 1 1.907 0z",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.309 1.022a.95.95 0 0 0-.554.126.95.95 0 0 1 .477.825v3.931a.477.477 0 0 0 .954 0V2c0-.502-.377-.937-.877-.977M13.403 2.924a.95.95 0 0 0-.554.126.95.95 0 0 1 .477.825v2.029a.477.477 0 1 0 .954 0V3.9c0-.501-.377-.937-.877-.977"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.372 31.366V14.58c0-.7.568-1.269 1.268-1.269h4.746c.7 0 1.268.568 1.268 1.269v16.786c0 .35-.284.634-.634.634h-6.014a.634.634 0 0 1-.634-.634",
  opacity: 0.8
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.372 15.636h7.282v.951h-7.282z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "#0EB0B0",
  opacity: 0.45
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.614 11.985a.907.907 0 0 1 1.813.004v3.855-2.046a.907.907 0 0 1 1.814 0v7.16c0 .999-.81 1.809-1.809 1.809H5.221a1.8 1.8 0 0 1-1.386-.647l-3.56-4.244a.828.828 0 0 1 1.204-1.133l1.146 1.087c.12.115.32.03.32-.137l.044-5.704a.906.906 0 0 1 1.812-.044v-.924a.906.906 0 1 1 1.813 0z",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.52 11.083a.9.9 0 0 0-.407.097c.296.15.499.455.499.81v3.832a.407.407 0 1 0 .815 0V11.99c0-.5-.406-.906-.907-.906M5.71 10.114a.9.9 0 0 0-.408.098c.296.15.5.455.5.809v4.467a.407.407 0 1 0 .814 0v-4.467c0-.5-.406-.907-.906-.907M3.896 11.083a.9.9 0 0 0-.407.097c.296.15.499.455.499.81v3.832a.407.407 0 1 0 .815 0V11.99c0-.5-.406-.906-.907-.906",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.242 31.366v-7.394c0-.666-.54-1.206-1.206-1.206h-4.51c-.666 0-1.206.54-1.206 1.206v7.394c0 .35.284.634.634.634h5.654c.35 0 .634-.284.634-.634",
  opacity: 0.6
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.318 24.952h6.923v.952H3.318z"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  fill: "#0EB0B0",
  opacity: 0.45
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.759 31.366v-7.394c0-.666.54-1.206 1.206-1.206h4.51c.666 0 1.206.54 1.206 1.206v7.394c0 .35-.284.634-.634.634h-5.654a.634.634 0 0 1-.634-.634",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.759 24.952h6.922v.952h-6.922z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.572 13.794a.907.907 0 0 0-1.813.004v7.16c0 .999.81 1.809 1.808 1.809h3.212c.534 0 1.042-.237 1.385-.647l3.56-4.244a.828.828 0 0 0-1.204-1.133l-1.145 1.087a.19.19 0 0 1-.321-.136l-.043-5.704a.906.906 0 0 0-1.813-.009v-.96a.907.907 0 0 0-1.813 0v.964a.907.907 0 0 0-1.813.004z",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.478 11.083a.9.9 0 0 0-.407.097c.296.15.499.455.499.81v3.833a.407.407 0 0 0 .815 0v-3.834c0-.5-.406-.906-.907-.906M26.291 10.114a.9.9 0 0 0-.407.098c.296.15.499.455.499.809v4.467a.407.407 0 1 0 .815 0v-4.467c0-.5-.406-.907-.907-.907M28.107 11.083a.9.9 0 0 0-.408.097c.296.15.5.455.5.81v3.833a.407.407 0 0 0 .814 0v-3.834c0-.5-.406-.906-.906-.906",
  opacity: 0.6
}))));
export default SvgRaisedHands;